import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { FALLBACK_LANGUAGE, SUPPORTED_LANGUAGES } from "./constants/constants";
import { getPathLang } from "./utils/lang";

// Create an instance so we can access addDetector
const languageDetector = new LanguageDetector();

// Custom detector to read language from the path
const pathDetector = {
  name: 'path',
  lookup() {
    return getPathLang();
  },
  cacheUserLanguage() {}  // required but can be a no-op
};

// Register the custom detector
languageDetector.addDetector(pathDetector);

i18n
  .use(initReactI18next)
  .use(languageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: FALLBACK_LANGUAGE,

    detection: {
      order: ["path", "cookie", "htmlTag"], // order and from where user language should be detected
      caches: ["cookie"], // cache user language on
    },

    backend: {
      loadPath: (lngs, namespaces) => {
        return namespaces.map(ns => 
          `${process.env.PUBLIC_URL}/locale/${lngs[0]}/${ns}.json?v=1.1.22`
        );
      }
    },

    ns: ['translation', 'content'],
    defaultNS: 'translation',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
